import { checkDefined } from 'faro-common-model';
import { toStudyEntityModificationInfoType, } from './study-entity-modification-info-type.js';
export function toStudyEntityModificationInfo(info) {
    checkDefined(info.id, 'StudyEntityModificationInfo', 'id');
    checkDefined(info.entityType, 'StudyEntityModificationInfo', 'entityType');
    checkDefined(info.description, 'StudyEntityModificationInfo', 'description');
    checkDefined(info.modificationInfoType, 'StudyEntityModificationInfo', 'modificationInfoType');
    return {
        id: info.id,
        entityType: info.entityType,
        modificationInfoType: toStudyEntityModificationInfoType(info.modificationInfoType),
        description: info.description,
        oldValue: info.oldValue,
        newValue: info.newValue,
    };
}
//# sourceMappingURL=study-entity-modification-info.js.map